<mat-card *ngIf="question" class="mat-elevation-z1">
  <mat-card-header class="question-header text-disabled-color mat-body-strong">
    <mat-card-title>
      <span *ngIf="section">
        {{section.name}}:&nbsp;
      </span>
      <ng-container i18n="General|Contest question term@@general-contest-question-term">Question</ng-container>
      <span *ngIf="question.index;else noQuestionIndex">&thinsp;{{question.index}}</span>
      <ng-template #noQuestionIndex>
        &nbsp;
        <ng-container i18n="General|No data provided@@general-no-data-provided">[no data]</ng-container>
      </ng-template>
    </mat-card-title>
    <mat-card-subtitle class="question-subtitle mat-small">
      <ng-container i18n="General|Contest question points term@@general-contest-question-points-term">Reward points:
      </ng-container>
      &nbsp;{{question.points}}
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <div>
      <div class="text-disabled-color" i18n="Contest Tasks|Question text title@@contest-tasks-question-text-title">
        Task:
      </div>
      <div *ngIf="question.text;else noContent" class="no-focus task-text" [innerHTML]="question.text"></div>
      <ng-template #noContent>
        <span class="text-disabled-color"
              i18n="Contest Tasks Editor|Contest question no text placeholder@@contest-tasks-editor-question-no-text-placeholder">
          No text provided...
        </span>
      </ng-template>
    </div>

    <div *ngIf="question.image" class="question-image-holder">
      <img [src]="question.image" class="question-image" alt="question-image"
           [class.exam]="examMode"
           [class.compact]="editMode">
    </div>

    <media-playback [audioUrl]="question.audio" class="question-audio-holder"></media-playback>
    <media-playback [videoUrl]="question.video" class="question-video-holder"></media-playback>

    <div>
      <div class="text-disabled-color">
        <span i18n="Contest Tasks|Question answers title@@contest-tasks-question-answers-title">Answers:</span>
        &nbsp;
        <span>({{displayType(question.type)}})</span>
      </div>
      <mat-selection-list #multiAnswerList
                          [disabled]="disabled || (examMode && question.answerInProgress)"
                          (selectionChange)="setMultipleAnswerCorrect($event, multiAnswerList)"
                          [compareWith]="compareAnswers">
        <mat-list-option *ngFor="let answer of question.answers"
                         checkboxPosition="before"
                         color="primary"
                         [value]="answer"
                         class="answer-list-option"
                         [class.no-background]="disabled"
                         [selected]="answer.correct">
          <div [innerHTML]="answer.text" class="word-wrap-word"></div>
        </mat-list-option>
      </mat-selection-list>
    </div>
  </mat-card-content>
  <mat-card-footer *ngIf="editMode || localizeMode || examMode"
                   class="question-footer"
                   [class.right-align]="editMode || localizeMode"
                   [class.center-align]="examMode">
    <app-button *ngIf="editMode || localizeMode"
                icon="mode_edit"
                [secondary]="true"
                (clicked)="edit.emit(question)"></app-button>
    <div *ngIf="editMode || localizeMode" class="btn-spacer"></div>
    <app-button *ngIf="editMode"
                icon="delete"
                [secondary]="true"
                [destructive]="true"
                (clicked)="delete.emit(question)"></app-button>

    <div *ngIf="examMode" class="exam-navigation">
      <app-button color="accent"
                  [disabled]="!backEnabled"
                  class="navigation-btn"
                  label="Previous"
                  i18n-label="General|Navigation previous term@@general-navigation-previous-term"
                  (clicked)="back.emit()"></app-button>
      <div class="fill-space"></div>
      <mat-spinner *ngIf="question.answerInProgress"
                   color="primary"
                   diameter="30"
                   class="center"></mat-spinner>
      <div class="fill-space"></div>
      <app-button color="primary"
                  [disabled]="!forwardEnabled"
                  class="navigation-btn"
                  label="Next"
                  i18n-label="General|Navigation next term@@general-navigation-next-term"
                  (clicked)="forward.emit()"></app-button>
    </div>
  </mat-card-footer>
</mat-card>
